<template>
  <div>
    <div class="wraper" v-if="!isProjectLoading">
      <div class="container-fluid mycontainer-fluid">
        <slot name="header"></slot>
        <ProjectHeader></ProjectHeader>
      </div>
      <div
        style="padding: 20px 30px;"
        class="container-fluid mycontainer-fluid content"
      >
        <div>
          <table class="co-executor" v-if="recordsLoaded">
            <thead>
              <tr>
                <th>Дата проведения встречи*</th>
                <th>Тип представителя*</th>
                <th>Должность лица*</th>
                <th>Фамилия*</th>
                <th>Имя*</th>
                <th>Отчество*</th>
                <th>Телефон 1*</th>
                <th>Телефон 2</th>
                <th>E-mail*</th>
                <td></td>
              </tr>
            </thead>
            <tbody>
              <template v-for="item in records">
                <MeetingList
                  :item="item"
                  :index="index"
                  v-bind:key="index"
                ></MeetingList>
              </template>
              <tr v-if="records.length < 5">
                <td colspan="10">
                  <div class="add-row">
                    <a class="link-add-row" v-on:click="addItem"
                      >Добавить встречу</a
                    >
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <project-menu></project-menu>
  </div>
</template>

<script>
import Vue from "vue";
import { mapGetters } from "vuex";
import { FETCH_PROJECT, FETCH_DIRECTORY } from "../../store/actions.type";
import ProjectHeader from "@/components/project/partial/ProjectHeader";
import { ProjectsService } from "@/common/api.service";
import { AUTH_URL } from "@/common/config";
import ProjectMenu from "@/components/project/partial/ProjectMenu";
import MeetingList from "@/components/project/form/lists/MeetingList";

Vue.filter("fileName", function(value) {
  let l = value.split("/");

  return l[l.length - 1];
});

export default {
  name: "Meetings",
  title: "Встречи",
  watch: {},
  computed: {
    ...mapGetters([
      "project",
      "isLoading",
      "directory",
      "currentUser",
      "notifications"
    ])
  },
  data() {
    return {
      recordsLoaded: true,
      records: [],
      siteUrl: ""
    };
  },
  components: {
    MeetingList,
    ProjectMenu,
    ProjectHeader
  },
  methods: {
    async fetchProject() {
      await this.$store.dispatch(FETCH_PROJECT, this.$route.params.id);

      ProjectsService.getListMeetingsProject(this.project.ID).then(response => {
        this.mapRecords(response.data.items);
      });
    },
    getStatus: function(id) {
      let t = this.directory.status.filter(c => c.ID === id);
      if (t.length > 0) {
        return t[0];
      }
    },
    addItem() {
      ProjectsService.addMeetingProject(this.project.ID, {
        UF_PROJECT_ID: this.project.ID,
        UF_DATE_METTINGS: "",
        UF_TYPE_CONTACT_ID: 0,
        UF_POSITION: "",
        UF_SURNAME: "",
        UF_NAME: "",
        UF_SECOND_NAME: "",
        UF_PHONE: "",
        UF_PHONE2: "",
        UF_EMAIL: ""
      }).then(() => {
        ProjectsService.getListMeetingsProject(this.project.ID).then(
          response => {
            this.mapRecords(response.data.items);
          }
        );
      }, this);
    },
    deleteItem(id) {
      ProjectsService.deleteMeetingProject(this.project.ID, id).then(() => {
        ProjectsService.getListMeetingsProject(this.project.ID).then(
          response => {
            this.mapRecords(response.data.items);
          }
        );
      }, this);
    },
    mapRecords(records) {
      this.records = [];
      records.forEach(function(r) {
        r.HAS_UF_DATE_METTINGS_ERROR = false;
        r.HAS_UF_TYPE_CONTACT_ID_ERROR = false;
        r.HAS_UF_POSITION_ERROR = false;
        r.HAS_UF_SURNAME_ERROR = false;
        r.HAS_UF_NAME_ERROR = false;
        r.HAS_UF_SECOND_NAME_ERROR = false;
        r.HAS_UF_PHONE_ERROR = false;
        r.HAS_UF_PHONE2_ERROR = false;
        r.HAS_UF_EMAIL_ERROR = false;
        this.records.push(r);
      }, this);
    },
    updateItem(item) {
      let hasError = false;
      if (item.UF_DATE_METTINGS === "") {
        item.HAS_UF_DATE_METTINGS_ERROR = true;
        hasError = true;
      } else {
        item.HAS_UF_DATE_METTINGS_ERROR = false;
      }
      if (!item.UF_TYPE_CONTACT_ID) {
        item.HAS_IR_HAS_UF_TYPE_CONTACT_ID_ERRORERROR = true;
        hasError = true;
      } else {
        item.HAS_UF_TYPE_CONTACT_ID_ERROR = false;
      }

      if (!item.UF_POSITION) {
        item.HAS__ERROR = true;
        hasError = true;
      } else {
        item.HAS__ERROR = false;
      }
      if (!item.UF_SURNAME) {
        item.HAS_UF_SURNAME_ERROR = true;
        hasError = true;
      } else {
        item.HAS_UF_SURNAME_ERROR = false;
      }
      if (!item.UF_NAME) {
        item.HAS_UF_NAME_ERROR = true;
        hasError = true;
      } else {
        item.HAS_UF_NAME_ERROR = false;
      }
      if (!item.UF_SECOND_NAME) {
        item.HAS_UF_SECOND_NAME_ERROR = true;
        hasError = true;
      } else {
        item.HAS_UF_SECOND_NAME_ERROR = false;
      }
      if (!item.UF_PHONE) {
        item.HAS_UF_PHONE_ERROR = true;
        hasError = true;
      } else {
        item.HAS_UF_PHONE_ERROR = false;
      }
      if (item.UF_EMAIL === "") {
        item.HAS_UF_EMAIL_ERROR = true;
        hasError = true;
      } else {
        item.HAS_UF_EMAIL_ERROR = false;
      }

      if (!hasError) {
        ProjectsService.editMeetingProject(this.project.ID, item.ID, item).then(
          () => {
            ProjectsService.getListMeetingsProject(this.project.ID).then(
              response => {
                this.records = response.data.items;
              }
            );
          },
          this
        );
      }
    }
  },
  async created() {
    this.siteUrl = AUTH_URL.replace(new RegExp("[\\/]+$"), "");
    await this.$store
      .dispatch(FETCH_DIRECTORY, ["status"])
      .then(() => {}, this);

    await this.$store
      .dispatch(FETCH_DIRECTORY, ["type_present"])
      .then(() => {}, this);

    this.$store.dispatch(FETCH_DIRECTORY, ["program_fin_support"]).then(() => {
      this.fetchProject();
    }, this);
  }
};
</script>

<style scoped></style>
